import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getWasteCalendarApi,
    getWasteDictTreeApi,
    getWasteByDateApi,
    getWasteByIdApi,
    getStandardDataApi,
    getHazardousDataApi,
    postWasteCommentApi,
    putWasteCommentApi,
    postStandardDataApi,
    postHazardousDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
}

/* 获取日历上的数据 */
export const getWasteCalendarAction = createAsyncThunk(
    'WasteSlice/getWasteCalendarAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getWasteCalendarApi(params)
            return data.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典 */
export const getWasteDictDataAction = createAsyncThunk(
    'WasteSlice/getWasteDictDataAction',
    async (dictType, thunkAPI) => {
        const standardTypeDataDict = getWasteDictTreeApi(dictType[0]) // 事件
        const unitTypeDataDict = getWasteDictTreeApi(dictType[1]) // 单位
        const WasteDataDict = getWasteDictTreeApi(dictType[2]) // 暴露类型
        const disposalTypeDataDict = getWasteDictTreeApi(dictType[3]) // 暴露时长
        return Promise.all([standardTypeDataDict, unitTypeDataDict, WasteDataDict, disposalTypeDataDict])
            .then(dictData => dictData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 通过日期获取 id */
export const getWasteByDateAction = createAsyncThunk(
    'WasteSlice/getWasteByDateAction',
    async (listDataParams, thunkAPI) => {
        try {
            const commentData = await getWasteByDateApi(listDataParams) // 通过日期查询 id
            return commentData?.data?.data?.id
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据 */
export const getWasteDataAction = createAsyncThunk('WasteSlice/getWasteDataAction', async (id, thunkAPI) => {
    const commentData = getWasteByIdApi(id) // 通过 id 查询
    const standardData = getStandardDataApi(id)
    const hazardousData = getHazardousDataApi(id)
    return Promise.all([commentData, standardData, hazardousData])
        .then(listData => listData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 保存数据 */
export const postWasteDataAction = createAsyncThunk(
    'WasteSlice/postWasteDataAction',
    async ({ id, commentParams, standardParams, hazardousParams, isCopyData }, { dispatch }) => {
        let vid
        try {
            if (!id || isCopyData) {
                const commentData = await postWasteCommentApi(commentParams) // 新增
                vid = commentData.data.data.id
                await postStandardDataApi(standardParams, vid)
                await postHazardousDataApi(hazardousParams, vid)
                dispatch(WasteSlice.actions.addId(vid))
                return { isTrue: true, id: vid } // 已保存状态
            } else {
                vid = id
                await putWasteCommentApi(commentParams, id) // 修改
                await postStandardDataApi(standardParams, id)
                await postHazardousDataApi(hazardousParams, id)
                return { isTrue: true, id } // 已保存状态
            }
        } catch (error) {
            dispatch(WasteSlice.actions.addId(vid))
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const WasteSlice = createSlice({
    name: 'WasteSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getWasteCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getWasteDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 提交总结数据 */
        [postWasteDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 获取回显数据 */
        [getWasteDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        },

        /* 通过日期，获取 id */
        [getWasteByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
